import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { FiFile } from "react-icons/fi";
import { SeAttachmentDto, SeAttachmentSource } from "../../../autogen/bff-api";
import { DownloadDocumentButton } from "../../documents/DownloadDocumentIconButton/DownloadDocumentButton";
import { useAttachmentSourceLabel } from "./attachmentSource";

const sourceChip: Record<SeAttachmentSource, { bg: string; fg: string }> = {
  [SeAttachmentSource.Request]: { bg: "smChipBlueBg", fg: "smChipBlueFg" },
  [SeAttachmentSource.Offer]: { bg: "smChipVioletBg", fg: "smChipVioletFg" },
  [SeAttachmentSource.Upload]: { bg: "smChipTealBg", fg: "smChipTealFg" },
};
// Neutral fallback so an unrecognized source (e.g. a value the client enum doesn't know yet) renders a chip
// instead of crashing the whole thread on `chip.bg`.
const fallbackChip = { bg: "smBorder", fg: "smText" };

export const AttachmentList = ({
  eventId,
  attachments,
}: {
  // Optional: when the sourcing-event id is unknown (e.g. the contract-origin view without an event link),
  // attachments are still listed but not downloadable — the download route is event-scoped.
  eventId?: string;
  attachments?: SeAttachmentDto[];
}) => {
  const sourceLabel = useAttachmentSourceLabel();
  if (!attachments || attachments.length === 0) return null;
  return (
    <Flex direction="column" gap="2" mt="2">
      {attachments.map((attachment) => {
        const chip = sourceChip[attachment.source] ?? fallbackChip;
        return (
          <Flex
            key={attachment.documentId}
            alignItems="center"
            justifyContent="space-between"
            gap="3"
            borderWidth="1px"
            borderColor="smBorder"
            rounded="md"
            px="3"
            py="2"
            bg="smBackground"
          >
            <Flex alignItems="center" gap="2" minW="0" flex="1">
              <Box color="smMuted" flexShrink="0">
                <FiFile size={16} />
              </Box>
              <Text fontSize="sm" noOfLines={1} title={attachment.fileName}>
                {attachment.fileName}
              </Text>
              <Badge bg={chip.bg} color={chip.fg} flexShrink="0">
                {sourceLabel(attachment.source)}
              </Badge>
            </Flex>
            {eventId && <DownloadDocumentButton documentId={attachment.documentId} eventId={eventId} />}
          </Flex>
        );
      })}
    </Flex>
  );
};
